import { handleActions, combineActions } from 'redux-actions'

import {
  onSetRecordId,
  updateRecordingState,
  onRecordingStarted,
  onRecordingStopped,
  onRecordingPaused,
  resetRecordingState,
} from '../actions'

const defaultValue = 0

export default handleActions(
  {
    [onSetRecordId](state, { payload }) {
      return payload
    },
    [combineActions(updateRecordingState, onRecordingStarted, onRecordingPaused)](state, { payload }) {
      return typeof payload.recordId !== 'undefined' ? payload.recordId : state
    },
    [combineActions(onRecordingStopped)](state, { payload }) {
      return 0
    },
    [resetRecordingState](state, { payload }) {
      return defaultValue
    },
  },
  defaultValue
)
